module.exports = __webpack_public_path__ + "static/img/shendujiance.57cf9b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shendujiance.png
// module id = 2u0e
// module chunks = 1